import PropTypes from "prop-types";
import { Component } from "react";

import h from "h";
import { fieldType } from "./PropTypes";
import LabelledField from "./LabelledField";
import ErrorContainer from "./ErrorContainer";
import Input from "./Input";

class CurrencyField extends Component {
  static propTypes = {
    width: PropTypes.number,
    label: PropTypes.string,
    field: fieldType,
    help: PropTypes.node,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    customHanders: PropTypes.object
  };

  render() {
    const {
      width,
      label,
      help,
      field,
      autoComplete,
      autoFocus,
      readOnly = false,
      optional = false,
      children,
      customHandlers
    } = this.props;

    return h(LabelledField, { width, label, help, optional }, [
      h(ErrorContainer, { field }, [
        h(".dollar-sign", h("span","$")),
        h(Input, {
          type: "text",
          field,
          className: "curr-input",
          props: { autoComplete, autoFocus, readOnly },
          customHandlers
        }),
        children
      ])
    ]);
  }
}

export default CurrencyField;
